import {T_SHIRT_SUBCAT_IDS} from './constants/categoryConstants';
import {visualFiltersTest} from './constants/signalmanConstants';

export const visualSubcategoryFiltersABTestEligible = (
  isInternal,
  isSearch,
  categoryId
) => {
  return !isInternal && !isSearch && T_SHIRT_SUBCAT_IDS.includes(categoryId);
};

export const visualSubcategoryFiltersABTestEnabled = (
  isInternal,
  isSearch,
  categoryId
) => {
  return (
    visualSubcategoryFiltersABTestEligible(isInternal, isSearch, categoryId) &&
    visualFiltersTest === 'test'
  );
};
